import lottie from 'lottie-web/build/player/lottie_light';
import { useEffect, useRef } from 'react';
import animationData from './ToniTaube.json';

interface Props {
  width: number;
  height: number;
}

export function ToniTaube({ width, height }: Props) {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!container.current) return;
    const anim = lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
    });

    return () => anim.destroy();
  }, []);

  return <div ref={container} style={{ width, height }} />;
}
